fx.ns("repositories", class FontsRepository extends fx.ModelArray {

	constructor()
	{
        super([]);

        this._isEmptyItem = false;
        this._isUsed = false;
    }

    addEmpty()
    {
        this._checkUsed();

        if (this._isUsed)
        {
            let item = {};
            item.empty = true;
    
            this.addItem(item);
    
            this._emptyItem = this.getItemAt(this.length - 1);
            this._isEmptyItem = true;
        }
    }

    getPaginationFonts(){
        var fonts = [];
        for(var i=0; i<this.length; i++)
        {
          if (  this.getItemAt(i).name == "Open Sans" || // Arial
                this.getItemAt(i).name == "Lora" || // Times
                this.getItemAt(i).name == "Cutive Mono" || // Courier
                this.getItemAt(i).name == "Fredoka One")
          {
            fonts.add(this.getItemAt(i));
          }
        }
        return fonts;
    }

    _checkUsed()
    {
        for (let i = 0; i < this.length; i++)
        {
            if (this.getItemAt(i).used)
            {
                this._isUsed = true;
                return;
            }
        }
    }

    changeCount(fontid)
    {
        let font = this.find({id : fontid});
        if (font)
            font.used ++;
    }

    refresh()
    {
        if (!this._isEmptyItem)
            this.addEmpty();

        this.moveItemAt(this.length-1, this._emptyItem);

        this.sort(this._sort);
        
        this._moveEmpty();
        
        this.trigger({type:"updated", action : new fx.Action("update")});
    }

    loadDataURI(fonts)
    {
        //let fontsToLoad = this.filter( font => !font.dataURI );
        var fontsToLoadIds = [];
        for(var i=0; i<fonts.length; i++){
            if(!fonts[i].dataURI){
                fontsToLoadIds.push(fonts[i].id);
            }
        }
        if (fontsToLoadIds.length == 0)
            this.trigger("font-data-uri-loaded");
        else
        // fontsToLoadIds => [1,4,6]
            this.post("/app/fonts",  { action : "datauri", fonts : fontsToLoadIds}, this._loadedDataURI, {timeout : 15000, maxTries : 0} ); // we wait 15 seconds max for fonts
    }

    _loadedDataURI(data)
    {
        var fonts = [];
        if (!data || data.error)
            this.trigger("load-fonts-datauri-error", data);
        else
        {
            for(let i = 0; i < data.length; i++)
            {
                this.find({id :  data[i].id}).dataURI = data[i].data;
                //let font = this.find({id :  data[i].id});
                //if (font)
                //    font.dataURI = data[i].data;   
                //fonts.push(font);    
            }
            this.trigger("font-data-uri-loaded", fonts);
        }
    }

    _sort(a, b)
    {
        return b.used - a.used;
    }

    _moveEmpty()
    {
        let notUsed = this.find({used : 0});
        let index = this.indexOf(notUsed);

        this.moveItemAt(index, this._emptyItem);
    }
});